import React from 'react';
import { useCarousel } from '../common/landingHooks';

const ChevronL = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6" /></svg>;
const ChevronR = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6" /></svg>;

const QUOTES = [
    { q: 'Diligentsia is genuinely solving a problem that has plagued the SME investment ecosystem for decades. The platform makes investor readiness accessible to everyone — not just those who can afford £40k diligence.', a: '— Paul Morris, Head of Growth Advisory' },
    { q: 'The ability to help companies self-certify their readiness is a game-changer. It changes the quality of the deal flow coming through the ecosystem.', a: '— Alex Faulconbridge, Investment Manager' },
    { q: "Having worked with hundreds of growth businesses, I've seen the gap between investment-ready and investment-unready close deals time and again. Diligentsia finally bridges it systematically.", a: '— Jim Tunstall, formerly Innovate UK Scaleup Programme Director' },
];

const GLOWS = [
    { top: 593, left: -182, size: 480, c: 'rgba(135,38,48,.42)' },
    { top: -230, right: -100, size: 540, c: 'rgba(20,36,119,.4)' },
    { top: 476, left: 67, size: 520, c: 'rgba(34,47,115,.34)' },
];

const pos = (v) => (v == null ? 'auto' : typeof v === 'number' ? v + 'px' : v);

const AboutQuotesSection = () => {
    const { viewportRef, trackRef, page, pages, next, prev, goTo, pause, resume } = useCarousel(QUOTES.length, { autoplayMs: 5500 });

    return (
        <section className="lp-quotes">
            <div className="lp-quotes-bg" aria-hidden="true">
                {GLOWS.map((g, i) => (
                    <i key={i} style={{ top: pos(g.top), left: pos(g.left), right: pos(g.right), width: g.size + 'px', height: g.size + 'px', background: `radial-gradient(circle, ${g.c}, ${g.c.replace(/[\d.]+\)$/, '0)')} 70%)`, filter: 'blur(80px)' }} />
                ))}
            </div>

            <div className="lp-sec-head">
                <h2 className="lp-h2" data-lp-reveal>Trusted by investors, advisors, and companies.</h2>
                <div className="lp-arrows">
                    <button className="lp-arrow" aria-label="Previous quotes" onClick={prev}><ChevronL /></button>
                    <button className="lp-arrow" aria-label="Next quotes" onClick={next}><ChevronR /></button>
                </div>
            </div>

            <div className="lp-viewport" onMouseEnter={pause} onMouseLeave={resume}>
                <div className="lp-vp-inner" ref={viewportRef}>
                    <div className="lp-slide-anim">
                        <div className="lp-track" ref={trackRef}>
                            {QUOTES.map((item, i) => (
                                <figure className="lp-qcard" key={i} data-lp-reveal data-lp-delay={(i % 3) * 120}>
                                    <div className="mark">“</div>
                                    <blockquote>{item.q}</blockquote>
                                    <figcaption>{item.a}</figcaption>
                                </figure>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            <div className="lp-foot">
                <p data-lp-reveal>What they say.</p>
                <div className="lp-dots" style={{ margin: 0, padding: 0 }}>
                    {Array.from({ length: pages }).map((_, i) => (
                        <button key={i} className={`lp-dot ${i === page ? 'is-active' : ''}`} aria-label={`Go to slide ${i + 1}`} onClick={() => goTo(i)} />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default AboutQuotesSection;
